import { Container } from '@ui';
import { Body1 } from '@ui';
import { FlatButton } from '@ui/buttons';
import { CloseButton } from '@ui/buttons/CloseButton';
import styled from 'styled-components';
import React from 'react';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const HeaderActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;
export const Header = ({ text, onDismiss }) => {
  const navigate = useNavigate();

  const onUploadNewDocumentsClick = () => {
    const url = ROUTES.docManagement;
    navigate(url);
  };

  return (
    <HeaderWrapper>
      <Container row verticallyCenter spaceBetween fullWidth>
        <Container>
          <Body1 bold>{text || 'Select Source Documents'}</Body1>
        </Container>
      </Container>
      <Container top={0} left={16} right={8}>
        <HeaderActionsWrapper>
          <SkeletonButton onClick={onUploadNewDocumentsClick}>Upload New Documents</SkeletonButton>
          <FlatButton onClick={onDismiss}>Save</FlatButton>
          <Container>
            <CloseButton onClick={onDismiss} />
          </Container>
        </HeaderActionsWrapper>
      </Container>
    </HeaderWrapper>
  );
};
